import Typography from "@/components/typography/Typography"
import BookDemoButton from "@/components/website/book-demo-button/BookDemoButton"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import BenefitItem, {
  BenefitCardContent,
  benefitImages,
} from "@/pages/website-landing/home/new-sections/benefits-section/benefir-item/BenefitItem"
import { Col, Row } from "antd"
import { FC } from "react"
import "./BenefitsSection.less"
import bgImage from "./assets/hexagons-formatted.webp"

import logo3D from "./assets/3d-logo.png"
import cross from "./assets/cross.png"
import waterMark from "./assets/easetech-watermark.svg"
import transparentLogo from "./assets/transparent-logo.png"
const { Title, Paragraph } = Typography

const benefitCardContent: BenefitCardContent[] = [
  {
    title: "More Applications Processed",
    description: "Handle higher volumes without increasing headcount.",
    image: "productivity",
    position: "topLeft",
  },
  {
    title: "Faster Turnaround Times",
    description: "Respond to applicants faster than ever.",
    image: "fast",
    position: "bottomLeft",
  },
  {
    title: "30%+ Cost Savings",
    description: "Reduce annual wayleave processing costs.",
    image: "saving",
    position: "topRight",
  },
  {
    title: "Focus on What Matters",
    description: "Let automation handle the repetitive work.",
    image: "auto",
    position: "bottomRight",
  },
]

const BenefitsSection: FC = () => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div className={"benefits-section-wrapper"}>
      <div className={"bg-image-wrapper"}>
        <img src={bgImage} alt={""} loading={"lazy"} decoding={"async"} />
      </div>

      {md && !lg && (
        <div className={"bg-logo-img"}>
          <img src={waterMark} alt={""} loading={"lazy"} decoding={"async"} />
        </div>
      )}

      <div className={"container"}>
        <Row className={"benefits-row"} justify={"center"}>
          <Col span={24} style={{ paddingBottom: 40 }}>
            <Title level={xxl || xl || lg || md || sm ? 2 : 3} color={"white"} centered className={"title"}>
              <span className={"w300"}>{"The Impact Is "}</span>
              <span className={"orange-bold"}>{"Significant"}</span>
            </Title>
          </Col>

          <Col span={20}>
            <Row style={{ height: "100%" }}>
              <Col
                xxl={8}
                xl={8}
                lg={8}
                md={12}
                sm={24}
                xs={24}
                style={{
                  zIndex: 3,
                }}
              >
                {benefitCardContent
                  ?.slice(0, 2)
                  .map(it => (
                    <BenefitItem
                      key={it.image}
                      title={it.title}
                      description={it.description}
                      image={benefitImages[it.image]}
                      position={it?.position}
                    />
                  ))}
              </Col>

              <Col span={8} className={"central-col"}>
                <Row justify={"center"}>
                  <div className={"benefit-logo-wrapper"}>
                    <div className={"cross-wrapper"}>
                      <img src={cross} alt={""} loading={"lazy"} decoding={"async"} />
                    </div>

                    <img src={logo3D} alt={""} loading={"lazy"} decoding={"async"} />
                  </div>
                </Row>
              </Col>

              <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                {benefitCardContent
                  ?.slice(2, 4)
                  .map(it => (
                    <BenefitItem
                      key={it.image}
                      title={it.title}
                      description={it.description}
                      image={benefitImages[it.image]}
                      position={it?.position}
                    />
                  ))}
              </Col>
            </Row>
          </Col>
        </Row>

        <Row justify={"center"}>
          <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <div className={"orange-banner-wrapper"}>
              <div className={"transparent-logo-wrapper"}>
                <img src={transparentLogo} alt={""} loading={"lazy"} decoding={"async"} />
              </div>

              <div className={"orange-content-wrapper"}>
                <Title color={"white"} level={2} centered style={{ paddingBottom: 16 }}>
                  <span className={"w300"}>{"Make Wayleave Management "}</span>
                  <span className={"bold"}>{"Easier"}</span>
                </Title>

                <Paragraph color={"white"} size={"lg"} centered style={{ paddingBottom: 32 }}>
                  {"Increase efficiency, reduce manual work, and deliver faster outcomes with Easetech."}
                </Paragraph>

                <div className={"btn-wrapper"}>
                  <BookDemoButton type={"darkBlue"} />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default BenefitsSection
